module.exports = __webpack_public_path__ + "img/L_318_326.4fa85b87.png";